import React, { useEffect, useState } from "react";

export default function UpdateBanner() {
  const [waitingWorker, setWaitingWorker] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Check if update already fired before this component mounted
    if (window.__swWaitingWorker) {
      setWaitingWorker(window.__swWaitingWorker);
      setShow(true);
    }

    // Also listen for future update events
    const handleUpdate = (e) => {
      setWaitingWorker(e.detail);
      setShow(true);
    };

    window.addEventListener("swUpdate", handleUpdate);
    return () => window.removeEventListener("swUpdate", handleUpdate);
  }, []);

  const handleUpdate = () => {
    if (waitingWorker) {
      waitingWorker.postMessage({ type: "SKIP_WAITING" });
    }
    setShow(false);
    // Small delay to let skipWaiting take effect
    setTimeout(() => window.location.reload(), 300);
  };

  if (!show) return null;

  return (
    <div style={{
      position: "fixed",
      bottom: "90px",
      left: "50%",
      transform: "translateX(-50%)",
      backgroundColor: "#3a3a3a",
      padding: "14px 16px",
      borderRadius: "12px",
      display: "flex",
      alignItems: "center",
      gap: "12px",
      zIndex: 9999,
      boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
      maxWidth: "320px",
      width: "calc(100% - 32px)",
      fontSize: "0.88rem",
      flexWrap: "nowrap",
      WebkitFontSmoothing: "antialiased",
    }}>
      <span style={{
        flex: 1,
        fontWeight: 500,
        lineHeight: 1.4,
        color: "#ffffff",
        WebkitTextFillColor: "#ffffff",
      }}>
        A new version of ClubWeek is available
      </span>
      <button
        onClick={handleUpdate}
        style={{
          backgroundColor: "#50B4C8",
          color: "#ffffff",
          WebkitTextFillColor: "#ffffff",
          border: "none",
          borderRadius: "8px",
          padding: "6px 14px",
          fontWeight: 700,
          fontSize: "0.85rem",
          cursor: "pointer",
          whiteSpace: "nowrap",
          fontFamily: "inherit",
          flexShrink: 0,
        }}
      >
        Update
      </button>
      <button
        onClick={() => setShow(false)}
        style={{
          background: "none",
          border: "none",
          color: "#aaaaaa",
          WebkitTextFillColor: "#aaaaaa",
          fontSize: "1.2rem",
          cursor: "pointer",
          padding: "0 2px",
          lineHeight: 1,
          fontFamily: "inherit",
          flexShrink: 0,
        }}
      >
        ×
      </button>
    </div>
  );
}
